import React, { ReactElement } from 'react';
import type { Route } from 'next';
import dynamic from 'next/dynamic';
import classNames from 'classnames/bind';
import RootLayout from 'layouts/RootLayout';
import proxyAxios from 'api/proxyAxios';
import { endpoints } from 'api/endpoints';
import { TopArticlesCardType } from 'sections/Home/types';
// (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
// import { LeadFormParameters } from 'components/LeadForm/LeadForm.data';
import Breadcrumbs from 'components/Breadcrumbs';
import 'swiper/css';
import styles from 'pages/resources/freight-templates/sli/Sli.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = dynamic(() => import('sections/Resources/FreightTemplates/Sli/components/SectionHeader/'));
const SectionAbout = dynamic(() => import('sections/Resources/FreightTemplates/Sli/components/SectionAbout/'));
const SectionPurpose = dynamic(() => import('sections/Resources/FreightTemplates/Sli/components/SectionPurpose/'));
const SectionDocuments = dynamic(() => import('sections/Resources/FreightTemplates/Sli/components/SectionDocuments/'));
const SectionFaq = dynamic(() => import('sections/Resources/FreightTemplates/Sli/components/SectionFaq/'));
const SectionCallToAction = dynamic(() => import('sections/Resources/FreightTemplates/Sli/components/SectionCallToAction'));
// (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
// const SectionForm = dynamic(() => import('sections/Resources/FreightTemplates/Sli/components/SectionForm/'));
const SectionRelatedPosts = dynamic(() => import('sections/Resources/FreightTemplates/Sli/components/SectionRelatedPosts/'));

interface SliProps {
  articles: TopArticlesCardType[];
  pageTitle?: string;
  formUrl?: string;
  leadSubtype?: string;
}

export default function Sli({ articles, pageTitle, formUrl, leadSubtype }: SliProps) {
  return (
    <div className={cn('sli')}>
      <div className={cn('container')}>
        <Breadcrumbs
          mTop={64}
          mode="light"
          links={[
            { title: 'Freight Templates', href: '/resources/freight-templates' as Route },
            { title: 'Shipper\s Letter of Instruction', href: '' as Route },
          ]}
        />
      </div>
      <SectionHeader />
      <SectionAbout />
      <SectionPurpose />
      <SectionDocuments />
      <SectionFaq />
      <SectionCallToAction />
      {/* (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774) */}
      {/* <SectionForm
        pageTitle={pageTitle}
        formUrl={formUrl}
        leadSubtype={leadSubtype}
      /> */}
      <SectionRelatedPosts articles={articles} />
    </div>
  );
}

export const getStaticProps = async () => {
  const meta = {
    title: 'SLI Template Free Download | DF Alliance',
    description: 'Download a free shipper\'s letter of instruction (SLI) template from DF Alliance to provide clear shipping directions.',
    path: '/resources/freight-templates/sli',
  };

  // (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
  // 'FormParameters' - parameters, passed to 'Form' component in 'SectionForm' on all Benefits pages as additional data for CRM: 
  // const FormParameters = {
  //   pageTitle: LeadFormParameters.Sli.pageTitle,
  //   formUrl: LeadFormParameters.Sli.formUrl,
  //   leadSubtype: LeadFormParameters.Sli.leadSubtype,
  // };

  try {
    const { data: articles } = await proxyAxios(endpoints.blog.previewArticles + '?limit=3');

    return {
      props: {
        articles,
        ...meta,
        // (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
        // ...FormParameters,
      }
    };
  } catch (e) {
    console.log('endpoints.blog.previewArticles', e);
  }

  return {
    props: {
      articles: [],
      ...meta,
      // (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
      // ...FormParameters,
    },
  };
};

Sli.getLayout = function getLayout(page: ReactElement) {
  return <RootLayout>{page}</RootLayout>;
};
